module.exports = __webpack_public_path__ + "745c1cb91ceb3b87c4debc6d0e771e47.pdf";